export default {"src":"/oferta/_next/static/media/close.6d5e7883.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};